module.exports = __webpack_public_path__ + "@/assets/img/Huawei.fbd65e60.svg";